import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsInfrastructureMicrofrontendExperimentEnabled } from 'shared/selectors/abExperiments';

import { MAP_CONTAINER_ID } from '../../constants/map';
import { offerSelector } from '../../selectors';
import { selectHasNewObject } from '../../selectors/newObject';
import { getDealType, isRent, isSale } from '../../utils/deal_type';
import { getOfferType, isFlat } from '../../utils/offer_type';
import { MapsSectionContainer } from '../MapsSectionContainer';
import { NewbuildingMapLoadable } from '../NewbuildingMapContainer';

export const OfferMapContainer = () => {
  const offer = useSelector(offerSelector);
  const hasNewObject = useSelector(selectHasNewObject);
  const isInfrastructureMicrofrontendEnabled = useSelector(selectIsInfrastructureMicrofrontendExperimentEnabled);

  const isSaleOffer = React.useMemo(() => isSale(getDealType(offer)), [offer]);
  const isRentOffer = React.useMemo(() => isRent(getDealType(offer)), [offer]);
  const isFlatOffer = React.useMemo(() => isFlat(getOfferType(offer)), [offer]);

  if (isInfrastructureMicrofrontendEnabled) {
    return null;
  }

  if ((isSaleOffer || isRentOffer) && isFlatOffer && hasNewObject) {
    return (
      <div id={MAP_CONTAINER_ID}>
        <NewbuildingMapLoadable />
      </div>
    );
  }

  return <MapsSectionContainer />;
};
